import {ViewController} from "data/types/structure";
import {injectable, inject} from "inversify";
import {makeAutoObservable} from "mobx";
import {Bindings} from "data/constants/bindings";
import type {IRoundsStore} from "data/stores/rounds/rounds.store";
import {chunk, orderBy} from "lodash";
import {IRound} from "data/types/entities";
import {RoundType} from "data/enums";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {PRE_SEASON_ROUND_MAP} from "data/constants";

export interface IFiltersController extends ViewController {
	i18n: ILocalizationStore;

	get rounds(): IRound[][];

	get currentRound(): number;

	get preSeasonList(): IRound[];

	get playoffsList(): IRound[];

	get preSeasonNameMap(): Record<string, string>;

	isSelected(round: IRound): boolean;

	onSelectRound(roundID: number): void;
}

@injectable()
export class FiltersController implements IFiltersController {
	constructor(
		@inject(Bindings.RoundsStore) private _roundsStore: IRoundsStore,
		@inject(Bindings.LocalizationStore) public i18n: ILocalizationStore
	) {
		makeAutoObservable(this);
	}

	get rounds() {
		return chunk(this.regularSeasonList, 6);
	}

	get regularSeasonList() {
		return this._roundsStore.list.filter((round) => round.type === RoundType.REG);
	}

	get preSeasonNameMap(): Record<string, string> {
		return PRE_SEASON_ROUND_MAP;
	}

	get preSeasonList() {
		return orderBy(
			this._roundsStore.list.filter((round) => round.type === RoundType.PRE),
			"number"
		);
	}

	get playoffsList() {
		return this._roundsStore.list.filter((round) => round.type === RoundType.POST);
	}

	get currentRound() {
		return 0;
	}

	dispose(): void {
		return;
	}

	init() {
		return;
	}

	isSelected(round: IRound) {
		return this._roundsStore.currentRound?.id === round.id;
	}

	onSelectRound(roundID: number) {
		this._roundsStore.selectedRoundID = roundID;
	}
}
